'use client';

import { motion, useInView } from 'motion/react';
import { useRef } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ArrowRight, BookOpen } from 'lucide-react';
import { isFinnishPage, BLOG_FI, BLOG_EN } from '../../../lib/blogPaths';

const BLOG_SLUG_UI_UX_FI = 'ui-ja-ux-mita-eroa-niilla-on';
const BLOG_SLUG_UI_UX_EN = 'ui-and-ux-what-is-the-difference-between-them';

export function UiUxBlogPromoSection() {
  const ref = useRef(null);
  const router = useRouter();
  const isInView = useInView(ref, { once: true, margin: '-60px' });
  const isFinnish = isFinnishPage(router?.pathname);
  const blogSlug = isFinnish ? BLOG_SLUG_UI_UX_FI : BLOG_SLUG_UI_UX_EN;
  const blogHref = isFinnish ? `${BLOG_FI}/${blogSlug}` : `${BLOG_EN}/${blogSlug}`;
  const teaser = 'UI/UX Design';
  const title = isFinnish ? 'UI ja UX – mitä eroa niillä on?' : "UI and UX – what's the difference?";
  const ctaLabel = isFinnish ? 'Lue artikkeli' : 'Read article';

  return (
    <section ref={ref} className="py-10 md:py-14 bg-[#f8fafc]">
      <div className="max-w-7xl mx-auto px-6">
        <Link href={blogHref} className="block group">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
            className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8 p-8 md:p-10 rounded-2xl border border-gray-200 bg-white shadow-sm hover:shadow-md hover:border-gray-300 transition-all duration-300"
          >
            <span className="flex items-center justify-center w-14 h-14 rounded-xl bg-gray-200 text-gray-800 shrink-0">
              <BookOpen className="w-7 h-7" aria-hidden />
            </span>
            <div className="flex-1 text-center sm:text-left min-w-0">
              <p className="text-gray-600 text-base md:text-lg mb-1">
                {teaser}
              </p>
              <p className="text-gray-900 font-semibold text-lg md:text-xl">
                {title}
              </p>
            </div>
            <span className="inline-flex items-center gap-2 text-brand font-semibold text-base group-hover:gap-3 transition-all shrink-0">
              {ctaLabel}
              <ArrowRight className="w-5 h-5 shrink-0 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </motion.div>
        </Link>
      </div>
    </section>
  );
}
